import { Form, FormSaveButton } from '@ztechapps/webui.form'
import type { WorkOrderAddComponent } from '@ztechapps/work-order.webui'
import { useWorkOrderAddContext } from '@ztechapps/work-order.webui'
import { WorkOrderAddProvider } from '@ztechapps/work-order.webui'
import React from 'react'
import type { SaveCancelButtonsProps } from '@ztechapps/webui.button'
import { Stack } from 'react-bootstrap'
import { HorizontalStack } from '@ztechapps/webui.util'

const WorkOrderFormSave = (_props: SaveCancelButtonsProps) => <FormSaveButton text="Create" />
const components = {
  saveCancelButtons: WorkOrderFormSave,
} as WorkOrderAddComponent
export const AddProduction = ({ onCloseMenu }: { onCloseMenu: () => void }) => {
  return (
    <WorkOrderAddProvider components={components}>
      <Layout onCloseMenu={onCloseMenu} />
    </WorkOrderAddProvider>
  )
}

export const Layout = ({ onCloseMenu }: { onCloseMenu: () => void }) => {
  const { initialValues, validate, onSubmit, onReset, components } = useWorkOrderAddContext()

  const onSubmitCore = async (args) => {
    await onSubmit(args)
    onCloseMenu()
  }

  return (
    <Form initialValues={initialValues} validate={validate} onSubmit={onSubmitCore} onReset={onReset}>
      <Stack gap={2}>
        <components.formInput />
        <HorizontalStack className="justify-content-end">
          <div>
            <components.saveCancelButtons />
          </div>
        </HorizontalStack>
      </Stack>
    </Form>
  )
}
